<template>
  <div class="broadcast-main">
    <div class="form-container">
      <div class="scroll-container">
        <div class="title">Broadcast Message</div>
        <div class="page-caption">Use the form below to broadcast an in-browser message to all/specified user that is using DSM6G</div>
        <Input placeholder="From" :isRequired="true" :inputValue.sync="from" />
        <RemarksBox title="Broadcast Message" :text.sync="message" :isRequired="true" :freeText="true" style="height: 200px" />
        <!-- <textarea id="messageContainer"></textarea> -->
        <div class="row-item">
          <div>Background Color</div>
          <input type="color" v-model="background">
          <button v-show="background != '#ADD8E6'" @click="background = '#ADD8E6'">Reset</button>
        </div>
        <div class="row-item">
          <div>Text Color</div>
          <input type="color" v-model="textColor">
          <button v-show="textColor != '#000000'" @click="textColor = '#000000'">Reset</button>
        </div>
        <CheckBox title="User Can Close" :isChecked.sync="closeable" />
        <div class="row-item">
          <div>Timeout</div>
          <input type="range" v-model="timeout" max="20" min="0">
          <input type="number" v-model="timeout" max="20" min="0" style="text-align: right">seconds
        </div>

        <div class="row-item">
          <CheckBox title="Send To All" :isChecked.sync="sendToAll" @checkBoxClicked="sendToChecked('sendToAll')" />
          <CheckBox title="Customize Recipients" :isChecked.sync="customRecipient" style="margin-left: 15px" @checkBoxClicked="sendToChecked('customRecipient')" />
        </div>

        <div v-if="customRecipient" class="row-item">
          <BoxContainer title="User" class="row-box">
            <Input placeholder="User" @keyDown="recipientsKeydown($event, 'user')" :inputValue.sync="userValue" />
            <div class="listing">
              <div class="list-item" v-for="(v, i) in userListing" :key="i">
                <div>{{ v }}</div>
                <div class="delete" @click="userListing.splice(i, 1)">❌</div>
              </div>
            </div>
          </BoxContainer>
          <BoxContainer title="Company" class="row-box">
            <Input placeholder="Company" @keyDown="recipientsKeydown($event, 'comp')" :inputValue.sync="companyValue" />
            <div class="listing">
              <div class="list-item" v-for="(v, i) in companyListing" :key="i">
                <div>{{ v }}</div>
                <div class="delete" @click="companyListing.splice(i, 1)">❌</div>
              </div>
            </div>
          </BoxContainer>
          <BoxContainer title="Group" class="row-box">
            <Input placeholder="Group" @keyDown="recipientsKeydown($event, 'group')" :inputValue.sync="groupValue" />
            <div class="listing">
              <div class="list-item" v-for="(v, i) in groupListing" :key="i">
                <div>{{ v }}</div>
                <div class="delete" @click="groupListing.splice(i, 1)">❌</div>
              </div>
            </div>
          </BoxContainer>
        </div>
      </div>
      <button @click="broadcast">BROADCAST</button>
    </div>
    <div class="preview-container">
      <div class="title">Preview</div>
      <div class="preview-box" :style="{ backgroundColor: from && message ? background : 'lightblue', color: from && message ? textColor : 'black' }">
        <img class="preview-close" v-if="closeable && (from && message)" src="https://dsmapi.logistics.systems/dsm6gicons/icons8-close-90.png" alt="">
        <div v-if="from && message" >From: {{ from }}</div>
        <div v-if="from && message" >dd/MM/yyyy HH:mm</div>
        <div v-if="from && message"  class="preview-text" v-html="message"></div>
        <div v-else class="preview-not-available">Preview not available.<br>From and Message value is needed.</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      from: '',
      message: '',
      background: '#ADD8E6',
      textColor: '#000000',
      closeable: true,
      timeout: 0,
      sendToAll: true,
      customRecipient: false,
      userValue: '',
      userListing: [],
      companyValue: '',
      companyListing: [],
      groupValue: '',
      groupListing: [],
    }
  },
  props: {
  },
  methods: {
    recipientsKeydown: function(e, type) {
      if (e.key != 'Enter') {
        return;
      }

      switch (type) {
        case 'user':
          if (this.userValue) {
            this.userListing.splice(0, 0, this.userValue);
            this.userValue = '';
          }
          break;
        case 'comp':
          if (this.companyValue) {
            this.companyListing.splice(0, 0, this.companyValue);
            this.companyValue = '';
          }
          break;
        case 'group':
          if (this.groupValue) {
            this.groupListing.splice(0, 0, this.groupValue);
            this.groupValue = '';
          }
          break;
      }
    },
    sendToChecked: function(data) {
      this.sendToAll = false;
      this.customRecipient = false;

      this.$nextTick(() => this[data] = true);
    },
    broadcast: async function() {
      if (!this.from || !this.message) {
        this.$showAlert('error', 'Insufficient Data', 'Please enter the from and message to send a broadcast message.')
      } else {
        let send = await this.$apiCallV2('/SendUpdates/SendNotification', {
          from: this.from,
          text: this.message,
          backgroundColor: this.background,
          textColor: this.textColor,
          canClose: `${this.closeable}`,
          timeout: this.timeout * 1000,
          user: this.sendToAll ? '' : this.userListing.join(','),
          group: this.sendToAll ? '' : this.groupListing.join(','),
          company: this.sendToAll ? '' : this.companyListing.join(',')
        });
      }
    },
    // editorKeydown: function(e) {
    //   console.log(tinyMCE.get('messageContainer').getDoc().getElementById('tinymce').innerHTML);
    // }
  },
  mounted() {
    // tinymce.init({
    //   selector: '#messageContainer',
    //   resize: false,
    //   // plugins: 'print preview powerpaste casechange importcss searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists checklist wordcount tinymcespellchecker a11ychecker imagetools textpattern noneditable help formatpainter permanentpen pageembed charmap mentions quickbars linkchecker emoticons advtable export',
    //   plugins: [
    //     'advlist autolink lists link image imagetools charmap print preview anchor',
    //     'searchreplace visualblocks code fullscreen quickbars',
    //     'insertdatetime media table paste code help wordcount',
    //   ],
    //   toolbar: 'save | undo redo | formatselect | ' +
    //     'bold italic backcolor | alignleft aligncenter ' +
    //     'alignright alignjustify | bullist numlist outdent indent | ' +
    //     'removeformat | help',
    //   height: '300',
    //   // init_instance_callback: (editor) => {
    //   //   editor.on('BeforeExecCommand', (e) => this.mceCommand(e));
    //   // }
    // });
    // setTimeout(() => {
    //   tinymce.activeEditor.on('keydown', this.editorKeydown)
    // }, 5000);
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.broadcast-main {
  font-size: 12px;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 10px 45px;

  > .form-container, > .preview-container {
    background-color: white;
    border-radius: 5px;
    padding: 5px;

    > .title {
      width: 100%;
      text-align: center;
      font-size: 1.3em;
      font-weight: bold;
    }
  }

  > .form-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    > .scroll-container {
      height: 100%;
      overflow: auto;

      > .title {
        width: 100%;
        text-align: center;
        font-size: 1.3em;
        font-weight: bold;
      }

      > .page-caption {
        width: 100%;
        text-align: center;
      }

      > .row-item {
        display: flex;
        align-items: center;
        width: 100%;

        > :not(:first-child) {
          margin-left: 5px;
        }

        > .row-box {
          width: 100%;
          height: 300px;
          min-height: 300px;
          max-height: 300px;

          > .listing {
            height: 100%;
            width: 100%;
            overflow: auto;
            overflow-x: hidden;

            > .list-item {
              display: flex;
              align-items: center;
              padding: 5px;

              > :first-child {
                width: 100%;
                max-width: calc(100% - 23px);
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              > .delete {
                margin-left: 5px;
                cursor: pointer;
              }

              &:nth-child(odd) {
                background-color: rgb(230,230,230);
              }
            }
          }
        }
      }

      > :not(:first-child) {
        margin-top: 5px;
      }
    }

  }

  > .preview-container {
    max-width: 300px;
    min-width: 300px;
    height: 100%;
    margin-left: 5px;

    > .preview-box {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      padding: 5px;
      font-size: 10px;
      border-radius: 5px;
      border: 1px solid black;
      margin-bottom: 5px;
      width: 100%;
      min-height: 50px;

      > .preview-title {
        display: flex;
        align-items: center;
        width: 100%;
      }

      > .preview-close {
        position: absolute;
        right: 3px;
        top: 3px;
        height: 15px;
      }

      > .preview-text {
        width: 235px;
        font-size: 12px;
        font-weight: bold;
        margin-top: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        &:hover {
          white-space: pre-wrap;
        }
      }

      > .preview-not-available {
        width: 100%;
        text-align: center;
        color: indianred;
        font-size: 12px;
        font-weight: bold;
      }
    }
  }

  // > .form-container {
  //   height: 100%;
  //   overflow: auto;

  //   > .title {
  //     font-weight: bold;
  //     font-size: 1.2em;
  //     text-align: center;
  //   }
  // }
}
</style>